var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fv-button",class:{'loading': _vm.loading},attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.onClick}},[(!_vm.loading)?[_vm._t("default")]:_c('fv-loading')],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/framevuerk-builder/node_modules/pug-html-loader/lib!./node_modules/framevuerk-builder/node_modules/vue-loader/lib??vue-loader-options!./src/components/fvButton.vue?vue&type=template&id=bf5ba772&lang=pug&
// module id = 136
// module chunks = 0 1